import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {EditionModel} from './Edition.model';

@injectable()
export class EditionFactory
  implements BaseDomainFactory<EditionModel, EditionModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: EditionModel.Props): EditionModel {
    return this.modelsRegistry.put(new EditionModel(props));
  }
}
